import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const LinkedinLogo: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M.238 25.671c0-13.807 11.193-25 25-25s25 11.193 25 25-11.193 25-25 25-25-11.193-25-25Z" fill="#0077B5" />
      <g clipPath="url(#a)" fill="#fff">
        <path d="M16.632 14.308c-1.517 0-2.748 1.156-2.748 2.737 0 1.58 1.231 2.737 2.748 2.737 1.518 0 2.749-1.156 2.749-2.737 0-1.581-1.231-2.737-2.749-2.737ZM19.017 21.88H14.25v15.144h4.767V21.88ZM31.056 21.466c-2.46 0-4.07 1.592-4.532 2.524h-.062v-2.098h-4.584v15.143h4.767v-8.211c0-2.19 1.387-3.255 2.801-3.255 1.339 0 2.376.753 2.376 3.193v8.27h4.768V27.67c0-4.627-2.874-6.204-5.534-6.204Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="translate(13.884 14.308)" d="M0 0h22.707v22.727H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { LinkedinLogo };
